import React from 'react';
import LocationTemplate from './LocationTemplate';

const NewtonGrovePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Newton Grove"
      stateName="North Carolina"
      countyName="Sampson"
      zipCodes={["28366"]}
      latitude={35.2471}
      longitude={-78.3552}
      population={569}
      historicalFact="Incorporated in 1879, known for its unique traffic circle with 5 highways."
      nearbyTowns={[
        "Clinton, NC",
        "Dunn, NC",
        "Benson, NC",
        "Four Oaks, NC",
        "Turkey, NC",
        "Garland, NC",
        "Roseboro, NC",
        "Godwin, NC"
      ]}
    />
  );
};

export default NewtonGrovePage;